import {ACTION_TYPES} from "../../../core/consts";
import {AnalyticsEventHandler} from "../../../infrastructure/handlers/analytics-event-handler";
import {
  WebsiteModuleBolaoFloatingButtonClickEvent
} from "../models/bolao/website-module.bolao.floating-button.click-event";

export class WebsiteModuleFloatingButtonClickEventHandler extends AnalyticsEventHandler {
  type = ACTION_TYPES.floatingButtonClickEvent;

  async action(params) {
    const sendParams = {
      ...params,
      source: this.getScreen(this.state.currentLinkModel?.name),
    }

    const event: WebsiteModuleBolaoFloatingButtonClickEvent = new WebsiteModuleBolaoFloatingButtonClickEvent(sendParams);

    this.analyticsService.createEvent(event);
  }
}
